import * as shutdownFiltersData from './filtersData';
import * as fieldsData from './fieldsData';
import EventEmitter from '../../../../helpers/eventEmmiter';

const shutdownEvtNames = {
  autoResponseTemplateAddOrEdit: 'auto_response_template_add_or_edit',
  autoResponseTemplateDelete: 'auto_response_template_delete',
  newCompanyValue: 'new_company_value',
  setDraftCompanyValue: 'set_company_city_value',
  newCityValue: 'new_city_value',
  setDraftCityValue: 'set_draft_city_value',
  setDraftSelectValueBuilder: (fieldName) =>
    `set_draft_select_${fieldName}_value`,
};

const shutdownEmitter = new EventEmitter();

export { shutdownFiltersData, fieldsData, shutdownEvtNames, shutdownEmitter };
